// src/pages/Admin/SemestersEdit.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import EditConfirmationModal from '../../components/common/EditConfirmationModal';
import TitleWithBack from '../../components/common/TitleWithBack';

function SemestersEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [semesterName, setSemesterName] = useState('');
  const [tooltip, setTooltip] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showConfirm, setShowConfirm] = useState(false);

  useEffect(() => {
    axios.get(`/api/semesters/${id}`)
      .then(response => {
        setSemesterName(response.data.name);
        setLoading(false);
      })
      .catch(() => {
        setError('Error fetching semester details.');
        setLoading(false);
      });
  }, [id]);

  const updateSemester = async () => {
    try {
      await axios.put(`/api/semesters/${id}`, { name: semesterName });
      setTooltip('Semester updated successfully!');
      setTimeout(() => navigate('/admin/semesters'), 2000);
    } catch (err) {
      setTooltip('Error updating semester.');
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowConfirm(true);
  };

  if (loading) return <p>Loading semester data...</p>;
  if (error) return <div className="alert alert-danger">{error}</div>;

  return (
    <div className="container mt-2">
      <TitleWithBack title="Edit Semester" />
      <div className="card shadow-sm">
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Semester Name</label>
              <input 
                type="text" 
                className="form-control"
                value={semesterName}
                onChange={(e) => setSemesterName(e.target.value)}
                required
              />
            </div>
            <button type="submit" className="btn btn-primary">Update Semester</button>
          </form>
          {tooltip && (
            <div className={`mt-3 alert ${tooltip.startsWith('Error') ? 'alert-danger' : 'alert-success'}`}>
              {tooltip}
            </div>
          )}
        </div>
      </div>
      {showConfirm && (
        <EditConfirmationModal 
          title="Confirm Update"
          message="Are you sure you want to update this semester?"
          onConfirm={() => { setShowConfirm(false); updateSemester(); }}
          onCancel={() => setShowConfirm(false)}
        />
      )}
    </div>
  );
}

export default SemestersEdit;
